import React from "react";
import { useTranslation } from "react-i18next";
import zaloIcon from "../../assets/icon/Icon_of_Zalo.svg";
import useSectionDarkMode from "../../hooks/useSectionDarkMode";

const ZALO_OA_URL = "https://zalo.me/2982406548455583297";

export default function ZaloFloatingButton() {
  const { t } = useTranslation();
  const darkMode = useSectionDarkMode("bottom");

  return (
    <a
      href={ZALO_OA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("chat.zalo")}
      title={t("chat.zalo")}
      style={{ bottom: "calc(88px + var(--cookie-banner-h, 0px))" }}
      className={`
        fixed right-5 z-[900]
        w-14 h-14 rounded-full
        flex items-center justify-center
        backdrop-blur-[30px]
        transition-all duration-300
        shadow-lg
        hover:scale-105 active:scale-95
        ${darkMode ? "bg-white/20 text-neutral-13" : "bg-white/20 text-neutral-1"}
      `}
    >
      <img
        src={zaloIcon}
        alt=""
        className="w-9 h-9 object-contain"
        aria-hidden="true"
      />
    </a>
  );
}
